import React from "react";
import { Star } from "@phosphor-icons/react";

export default function StarRating({ value = 0, count, size = 16, editable = false, onChange }) {
  const rounded = Math.round(value);
  return (
    <div className="flex items-center gap-1" data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          disabled={!editable}
          onClick={() => editable && onChange?.(i)}
          className={editable ? "cursor-pointer" : "cursor-default"}
          data-testid={editable ? `rate-star-${i}` : undefined}
        >
          <Star
            size={size}
            weight={i <= rounded ? "fill" : "regular"}
            color={i <= rounded ? "#FF007F" : "#52525b"}
          />
        </button>
      ))}
      {typeof count === "number" && (
        <span className="font-mono text-xs text-zinc-400 ml-1">({count})</span>
      )}
    </div>
  );
}
